import React from 'react';

const AddCircle = ({size = "30px", color="#4b00ff", ...rest}) => {
    return (
        <button {...rest} style={{
            width: size,
            height: size,
            borderRadius: "50%",
            color: "#fff",
            fontWeight: "600",
            backgroundColor: color,
            border: "none",
            outline: "0"
        }}>
            +
        </button>
    );
};

export default AddCircle;